/**
 * Leadership Modal Module
 * Handles opening and closing the leadership profile modal
 */

export default function initLeadershipModal() {
  const modal = document.getElementById("leadership-modal");
  if (!modal) return;

  const overlay = modal.querySelector(".modal-overlay");
  const closeBtn = modal.querySelector(".modal-close");
  const modalImage = document.getElementById("modal-image");
  const modalName = document.getElementById("modal-name");
  const modalPosition = document.getElementById("modal-position");
  const modalBio = document.getElementById("modal-bio");

  const triggers = document.querySelectorAll(".view-profile");

  const openModal = (trigger) => {
    const name = trigger.getAttribute("data-name") || "";
    const position = trigger.getAttribute("data-position") || "";
    const image = trigger.getAttribute("data-image") || "";
    const bioContent = trigger.getAttribute("data-bio") || "";

    modalName.textContent = name;
    modalPosition.textContent = position;
    if (image) {
      modalImage.src = image;
      modalImage.alt = name;
      modalImage.style.display = "block";
    } else {
      modalImage.style.display = "none";
    }
    modalBio.innerHTML = bioContent;

    modal.classList.add("is-active");
    document.body.classList.add("modal-open");

    // Lenis handles scrolling inside data-lenis-prevent natively
    // Removed lenis.stop() to fix mobile scroll
  };

  const closeModal = () => {
    modal.classList.remove("is-active");
    document.body.classList.remove("modal-open");

    // Removed lenis.start()
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => openModal(trigger));
  });

  if (overlay) {
    overlay.addEventListener("click", closeModal);
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closeModal);
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-active")) {
      closeModal();
    }
  });
}
